// src/styles/minimalStyles.js (example path)

export const colors = {
  primaryText: '#333',       // Dark grey for primary text
  secondaryText: '#6b7280', // Medium grey for less important text
  border: '#e5e5e5',       // Light grey for borders
  backgroundLight: '#f8f9fa',// Very light grey for backgrounds sections
  white: '#ffffff',
  accent: '#007bff',       // Standard blue accent
  accentDark: '#0056b3',    // Darker blue for hover
};

export const typography = {
  fontFamily: "'Helvetica', Arial, sans-serif",
  baseSize: '1rem',
  largeTitleSize: '2.5rem',
  mediumTitleSize: '1.8rem',
  smallTitleSize: '1.2rem',
  normalWeight: 'normal',
  boldWeight: '600',
};

export const layout = {
  maxWidth: '1200px',
  containerPadding: '0 20px',
  sectionSpacing: '40px',
  gap: '20px',
};

export const commonStyles = {
  container: {
    maxWidth: layout.maxWidth,
    margin: '0 auto',
    padding: layout.containerPadding,
    fontFamily: typography.fontFamily,
    color: colors.primaryText,
  },
  section: {
    marginBottom: layout.sectionSpacing,
  },
  sectionTitle: {
    fontSize: typography.mediumTitleSize,
    fontWeight: typography.normalWeight,
    marginBottom: '20px',
    paddingBottom: '10px',
    borderBottom: `1px solid ${colors.border}`,
    fontFamily: typography.fontFamily,
    color: colors.primaryText,
  }
};